<template>
    <v-row
        v-bind="context.properties"
    >
      <template
          v-for="(subElement, index) in context.elements"
      >
        <dynamic-column
            v-if="subElement.vuetify ==='v-col'"
            :key="index"
            :column="subElement"
        />

        <v-divider
            :key="index"
            v-else-if="subElement.vuetify ==='v-divider'"
            v-bind="subElement.properties"
        />

        <template v-else-if="subElement.vuetify === 'dynamic-abstract'">
          <dynamic-abstract
              :key="index"
              :context="subElement"
          />
        </template>

      </template>

    </v-row>
</template>
<script>

import DynamicColumn from "@/components/DynamicColumn";
import globalMixins  from "@/mixins/globalMixins";

export default {
  name: 'DynamicRow',
  data(){
    return {
      context: {}
    }
  },
  props: {
    row: {
      type: Object
    }
  },

  mixins: [ globalMixins ],

  components: {
    DynamicColumn
  },

  async created(){

    let context = this._.cloneDeep(this.row);

    for(let i in context.properties){

      if(typeof context.properties[i] === 'string' && context.properties[i].trim() === ''){
        delete context.properties[i];
      }
      else{

        if(typeof context.properties[i] === 'string'){
          context.properties[i] = context.properties[i].toLowerCase();
        }

        if(i.includes('v-align')){
          let newL = i.replace('v-align-','align-');
          context.properties[newL] = context.properties[i];
          delete context.properties[i];
        }

        if(i.includes('v-justify')){
          let newL = i.replace('v-justify-','justify-');
          context.properties[newL] = context.properties[i].replace(/\s/g, '-');
          delete context.properties[i];
        }

        if(i.includes('v-no-gutters')){
          let newL = i.replace('v-no-gutters','no-gutters');
          context.properties[newL] = context.properties[i];
          delete context.properties[i];
        }
      }
    }

    this.context = context;
    this.$forceUpdate();
  }
}
</script>